<template>
  <section class="row">
    <div class="col-12 mb-2 d-flex flex-row gap-2 justify-content-between">
      <div class="fw-bold">
        Titulaire n°{{ index + 1 }}
      </div>
      <font-awesome-icon
        v-if="index > 0"
        icon="trash"
        class="cursor-pointer hover-primary"
        @click="$emit('remove')"
      />
    </div>
    <hr>
    <div class="col-12 d-md-flex flex-row gap-3 mb-2">
      <div class="w-50">
        <v-simple-input
          :input-id="`approver-first-name-${index}`"
          label="Prénom du titulaire"
          :value="approver.approverFirstName"
          placeholder="Nicolas"
          :validation-class="touchedApprover?.firstName ? `is-${isFirstNameValid ? 'valid' : 'invalid'}` : ''"
          :error-message="touchedApprover?.firstName && !isFirstNameValid ? 'Le prénom du titulaire est requis' : ''"
          @input="handleFirstNameInput"
          @blur="$emit('touch', 'firstName')"
        />
      </div>
      <div class="w-50">
        <v-simple-input
          :input-id="`approver-last-name-${index}`"
          label="Nom du titulaire"
          :value="approver.approverLastName"
          placeholder="Moreau"
          :validation-class="touchedApprover?.lastName ? `is-${isLastNameValid ? 'valid' : 'invalid'}` : ''"
          :error-message="touchedApprover?.lastName && !isLastNameValid ? 'Le nom du titulaire est requis' : ''"
          @input="handleLastNameInput"
          @blur="$emit('touch', 'lastName')"
        />
      </div>
    </div>
    <div class="col-12 mb-2">
      <label
        class="mb-1"
        :for="`professional-card-approver-position-${index}`"
      >
        Fonction
      </label>
      <select
        :id="`professional-card-approver-position-${index}`"
        class="form-control"
        :value="approver.position?.code || ''"
        @change="handlePositionChange"
      >
        <option value="">
          Sélectionnez une fonction
        </option>
        <option
          v-for="item in positionList"
          :key="item.code"
          :value="item.code"
        >
          {{ item.name || item.label }}
        </option>
      </select>
    </div>
    <hr>
  </section>
</template>

<script>
import SimpleInput from '@/components/common/input/SimpleInput.vue';

export default {
  name: 'ApproverItem',
  components: {
    'v-simple-input': SimpleInput,
  },
  props: {
    approver: { type: Object, required: true },
    index: { type: Number, required: true },
    touchedApprover: { type: Object, default: () => ({}) },
    positionList: { type: Array, required: true },
  },
  emits: ['update:first-name', 'update:last-name', 'update:position', 'touch', 'remove'],
  computed: {
    isFirstNameValid() {
      return Boolean(this.approver?.approverFirstName?.trim());
    },
    isLastNameValid() {
      return Boolean(this.approver?.approverLastName?.trim());
    },
  },
  methods: {
    handleFirstNameInput(value) {
      this.$emit('update:first-name', value);
    },
    handleLastNameInput(value) {
      this.$emit('update:last-name', value);
    },
    handlePositionChange(event) {
      const position = this.positionList.find(({ code }) => code === event.target.value) || null;
      this.$emit('update:position', position);
    },
  },
};
</script>
